import Vue from "vue";
import Router from "vue-router";
// import Layout from "@/Layout";
import cookie from "js-cookie";
// import store from "../store";
import { asyncRouterMap } from "./asyncRoutes";

Vue.use(Router);

export const payment = [];
// Base Routes
export const constantRouterMap = [
  ...asyncRouterMap,
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  {
    path: "/401",
    component: () => import("@/views/errorPage/401"),
    name: "Page401",
    hidden: true
  },
  {
    path: "/404",
    component: () => import("@/views/errorPage/404"),
    name: "Page404",
    hidden: true
  }
];

const router = new Router({
  mode: "history",
  routes: constantRouterMap
});
router.beforeEach((to, from, next) => {
  if (cookie.get("token")) {
    if (to.path === "/login") {
      next("/");
    } else {
      // console.log(store);
      next();
      // asyncRouterMap.forEach(el => {
      //   if (el.children) {
      //     el.children.forEach(child => {
      //       store.getters.permissions.some(per => {
      //         if (per === child.meta.permission) {
      //           // router.addRoutes([el]);
      //           // console.log(constantRouterMap);
      //           // next();
      //           console.log(child.meta.permission, "x", per);
      //         } else {
      //           next("/");
      //         }
      //       });
      //       //   console.log(child);
      //       //   router.addRoutes(el);
      //       //   next();
      //       // }
      //     });
      //   }
      // });
    }
  } else {
    if (to.path === "/login") {
      next();
    } else {
      next("/login");
    }
  }
});

export default router;
